import { render, staticRenderFns } from "./StudentTypeRegister.vue?vue&type=template&id=093736b5"
import script from "./StudentTypeRegister.vue?vue&type=script&lang=js"
export * from "./StudentTypeRegister.vue?vue&type=script&lang=js"
import style0 from "./StudentTypeRegister.vue?vue&type=style&index=0&id=093736b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports